import type { IPdfTemplate } from './IPdfTemplate'
import uaPdf from './uaPdf'

// TODO: Might need to load them dynamically

const templates: Record<number, IPdfTemplate> = {}
templates[uaPdf.id] = uaPdf

export default templates
